import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Globe, BarChart3, Newspaper, Rocket, ClipboardList } from "lucide-react";
import theme from "../../styles/theme";
import { WizardHatIcon } from "../common/Brand";

const T = theme.colors;

const NAV_TABS = [
  { key: "all", label: "Feed", Icon: Globe, path: "/" },
  { key: "analysis", label: "Analysis", Icon: BarChart3, path: "/analysis" },
  { key: "news", label: "News", Icon: Newspaper, path: "/news" },
  { key: "update", label: "Updates", Icon: Rocket, path: "/updates" },
  { key: "surveys", label: "Surveys", Icon: ClipboardList, path: "/surveys" },
];

export default function Navbar() {
  const location = useLocation();

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      style={{
        position: "sticky", top: 0, zIndex: 100,
        background: theme.gradients.nav,
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        borderBottom: `1px solid ${T.border}40`,
        padding: "0 24px",
      }}
    >
      <div
        style={{
          maxWidth: 1200, margin: "0 auto",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          height: 60,
        }}
      >
        {/* Logo */}
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 10, textDecoration: "none" }}>
          <div className="float">
            <WizardHatIcon size={32} color={T.purple} />
          </div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#fff", letterSpacing: "-0.02em", lineHeight: 1 }}>
              WYZCON
            </div>
            <div style={{ fontSize: 9, color: T.violet, fontFamily: theme.fonts.mono, letterSpacing: 3, textTransform: "uppercase" }}>
              Intelligence
            </div>
          </div>
        </Link>

        {/* Tabs */}
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          {NAV_TABS.map((tab) => {
            const TabIcon = tab.Icon;
            const active = isActive(tab.path);
            return (
              <Link
                key={tab.key}
                to={tab.path}
                style={{
                  display: "flex", alignItems: "center", gap: 5,
                  padding: "6px 14px", borderRadius: 8,
                  background: active ? T.purple + "30" : "transparent",
                  color: active ? T.violet : T.textMuted,
                  fontSize: 13, fontWeight: 500, textDecoration: "none",
                  transition: "all 0.15s",
                }}
              >
                <TabIcon size={14} /> {tab.label}
              </Link>
            );
          })}
        </div>

        {/* Live indicator */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div
            className="pulse"
            style={{ width: 8, height: 8, borderRadius: "50%", background: T.green }}
          />
          <span style={{ fontSize: 11, color: T.textDim, fontFamily: theme.fonts.mono }}>
            LIVE
          </span>
        </div>
      </div>
    </nav>
  );
}
